import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Textarea } from "../components/ui/textarea";
import { Star } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function ReviewDialog({ open, onOpenChange, bookingId, trainerName, onSubmitted }) {
  const [rating, setRating] = useState(5);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try {
      await api.post(`/bookings/${bookingId}/review`, { rating, comment });
      toast.success("Thanks for your review");
      onSubmitted?.();
      onOpenChange(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not submit");
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-sm" data-testid="review-dialog">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">Rate your session with {trainerName}</DialogTitle>
        </DialogHeader>
        <div className="space-y-5">
          <div className="flex gap-2 justify-center" data-testid="review-stars">
            {[1,2,3,4,5].map(n => (
              <button key={n} type="button"
                onMouseEnter={() => setHover(n)}
                onMouseLeave={() => setHover(0)}
                onClick={() => setRating(n)}
                data-testid={`star-${n}`}>
                <Star className={`w-9 h-9 transition-all ${(hover || rating) >= n ? "fill-primary text-primary" : "text-muted-foreground"}`} />
              </button>
            ))}
          </div>
          <Textarea value={comment} onChange={e => setComment(e.target.value)} rows={4} placeholder="Share what went well…" className="rounded-sm" data-testid="review-comment" />
          <Button className="w-full rounded-sm" onClick={submit} disabled={loading} data-testid="review-submit">
            {loading ? "Submitting…" : "Submit review"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
